import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { propToLocalStorage } from '../../shared/decorators/storage.decorator';

@Injectable({
  providedIn: 'root'
})
export class AutorizedUserGuard implements CanActivate {

  constructor(private router: Router) { }

  @propToLocalStorage('token')
  public token;

  @propToLocalStorage('user')
  public user;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.token && this.user) {
      return true;
    }
    this.router.navigate(['/authorization']);
    return false;
  }
}
